import difference from "lodash/difference";
import { useEffect, useRef } from "react";

export function useAutoArrayFocus<T extends { id: string }>(array: readonly T[]): void {
	const arrayMemory = useRef(array);

	useEffect(() => {
		const arrayIds = array.map((a) => a.id);
		const memoryIds = arrayMemory.current.map((a) => a.id);
		if (array.length > arrayMemory.current.length) {
			const addedAnswer = difference(arrayIds, memoryIds);
			if (addedAnswer.length === 1) {
				const answerInput = document.querySelector(`[data-id='${addedAnswer[0]}']`);
				if (answerInput) {
					(answerInput as HTMLElement).focus();
				}
			}
		} else if (array.length < arrayMemory.current.length) {
			const removedAnswer = difference(memoryIds, arrayIds);
			if (removedAnswer.length === 1) {
				const removedAnswerIndex = memoryIds.indexOf(removedAnswer[0]);
				if (removedAnswerIndex >= 0) {
					const answerInput = document.querySelector(
						`[data-id='${memoryIds[removedAnswerIndex === 0 ? 1 : removedAnswerIndex - 1]}']`
					);
					if (answerInput) {
						(answerInput as HTMLElement).focus();
					}
				}
			}
		}
		arrayMemory.current = array;
	}, [array.length]);
}
